import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import moment from 'moment/moment'
import PropTypes from 'prop-types'

import { useDialog } from '@smartcoop/dialog'
import { fullScreen } from '@smartcoop/icons'
import { WeatherForecastActions } from '@smartcoop/stores/weatherForecast'
import { momentBackDateFormat } from '@smartcoop/utils/dates'
import Icon from '@smartcoop/web-components/Icon'
import RainMapFragment from '@smartcoop/web-containers/fragments/RainMapFragment'
import RainScaleFragment from '@smartcoop/web-containers/fragments/RainScaleFragment'
import RainMapModal from '@smartcoop/web-containers/modals/RainMapModal'

import {
  CardItem,
  DotsContainer,
  MapContainer
} from './styles'

const RainMapFragmentCard = ({ property }) => {
  const { createDialog } = useDialog()
  const dispatch = useDispatch()

  const [aggregatedRain, setAggregatedRain] = useState([])

  useEffect(() => {
    dispatch(WeatherForecastActions.searchAggregatedRain(
      moment().subtract(30, 'days').format(momentBackDateFormat),
      moment().format(momentBackDateFormat),
      (response) => setAggregatedRain(response)
    ))
  }, [dispatch])

  const openModal = useCallback(
    () => createDialog({
      id: 'user-not-found',
      Component: RainMapModal,
      props: {
        property
      }
    }),
    [createDialog, property]
  )

  return (

    <CardItem
      headerRight={ (
        <DotsContainer onClick={ openModal }>
          <Icon icon={ fullScreen } style={ { cursor: 'pointer' } } />
        </DotsContainer>
      ) }
    >
      <MapContainer>
        <RainMapFragment aggregatedRain={ aggregatedRain } setAggregatedRain={ setAggregatedRain } property={ property } style={ { borderRadius: '10px 10px 0 0' } } />
      </MapContainer>
      <RainScaleFragment/>
    </CardItem>
  )}

RainMapFragmentCard.propTypes = {
  property: PropTypes.object.isRequired
}

export default RainMapFragmentCard
